export default "mutation UpdateUserPreference($key: String!, $value: String!) {\n  updateUserPreference(\n    key: $key,\n    value: $value\n  )\n}\n"